// extracted by mini-css-extract-plugin
export var buttons = "question-bank-module--buttons--c+0AB";
export var flexWrapper = "question-bank-module--flex-wrapper--mEmjC";
export var h1 = "question-bank-module--h1--agGCH";
export var information = "question-bank-module--information--rEjCH";
export var tag = "question-bank-module--tag--caVRQ";